import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useUpdateGoogleFreeBookingLinksSettingsHotelType } from "../../api";

import type { GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType } from "../../hooks";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<GoogleFreeBookingLinksSettingsHotelTypeZodSchemaType>;
	callbackFunc: () => void;
};

export const useHotelTypeSubmit = ({ form, callbackFunc }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { updateGoogleFreeBookingLinksSettingsHotelType } = useUpdateGoogleFreeBookingLinksSettingsHotelType();

	const handleSubmit = form.handleSubmit(async (input) => {
		showLoadingScreenCallback();
		const { data, errors } = await updateGoogleFreeBookingLinksSettingsHotelType(input);

		if (!data || errors?.length) {
			notifyUserEventInfo({
				variant: "error",
				title: "選択内容の送信に失敗しました",
				description: "お手数をおかけしますが、時間を置いてから再度お試しください。",
			});
		} else {
			notifyUserEventInfo({
				title: "選択内容を送信しました",
				description: "ご協力ありがとうございました。",
			});
			callbackFunc();
		}

		hideLoadingScreenCallback();
	});

	return { handleSubmit };
};
